<template>
  <div class="list-section">
    <div class="search-bg">
      <!-- 搜索表单 -->
      <el-form :inline="true" :model="searchForm">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text84') + '：'"
              class="search-label"
            >
              <el-input
                clearable
                v-model="searchForm.id"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text88') + '：'"
              class="search-label"
            >
              <el-input
                clearable
                v-model="searchForm.name"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="agentConfig.phoneLoginReg">
            <el-form-item
              :label="$t('proxy.text89') + '：'"
              class="search-label"
            >
              <el-input
                clearable
                v-model="searchForm.phone"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 所属代理筛选下拉 -->
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text257') + '：'"
              class="search-label"
            >
              <el-select clearable v-model="searchForm.SProxyId" placeholder="">
                <el-option
                  v-for="agent in formattedAgents"
                  :key="agent.proxyId"
                  :label="agent.indentedName"
                  :value="agent.proxyId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text266') + '：'"
              class="selector-search-label"
            >
              <el-select clearable v-model="searchForm.status" placeholder="">
                <el-option :label="$t('proxy.text47')" value="1"></el-option>
                <el-option :label="$t('proxy.text48')" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 第二行 -->
        <el-row :gutter="20">
          <el-col :span="4" v-if="agentConfig.emailLoginReg">
            <el-form-item
              :label="$t('proxy.text34') + '：'"
              class="search-label"
            >
              <el-input
                clearable
                v-model="searchForm.email"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('fundHistory.text8') + '：'"
              class="search-label"
            >
              <div class="date-range">
                <el-date-picker
                  v-model="searchForm.startTime"
                  type="date"
                  style="width: 140px"
                  format="MM/DD/YYYY"
                  value-format="YYYY-MM-DD"
                />
                <span class="date-separator">-</span>
                <el-date-picker
                  v-model="searchForm.endTime"
                  type="date"
                  style="width: 140px"
                  format="MM/DD/YYYY"
                  value-format="YYYY-MM-DD"
                />
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$t('proxy.text78') + '：'"
              class="selector-search-label"
            >
              <el-select
                clearable
                v-model="searchForm.openStatus"
                placeholder=""
              >
                <el-option :label="$t('proxy.text79')" value="1"></el-option>
                <el-option :label="$t('proxy.text80')" value="2"></el-option>
                <el-option :label="$t('proxy.text81')" value="3"></el-option>
                <el-option :label="$t('proxy.text82')" value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-form-item>
              <el-button
                type="primary"
                @click="searchFetchData"
                class="search-button"
                >{{ $t("proxy.text13") }}</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格和分页容器 -->
    <div class="table-container">
      <el-table
        :data="visibleData"
        style="height: calc(100vh - 300px); width: 100%"
        :border="true"
        :resizable="true"
      >
        <el-table-column
          min-width="180px"
          :label="$t('proxy.text88') + '/' + $t('proxy.text62')"
          fixed="left"
        >
          <template #header>
            <div class="header-with-line">
              {{ $t("proxy.text88") + "/" + $t("proxy.text62") }}
            </div>
          </template>
          <template #default="scope">
            <div
              :class="{
                'name-cell': scope.row.roleType === 2,
                'client-cell': scope.row.roleType !== 2,
              }"
            >
              <div
                class="expand-wrapper"
                :style="{ marginLeft: `${24 * (scope.row.level || 0)}px` }"
              >
                <span style="display: flex; align-items: center">
                  <img
                    v-if="scope.row.roleType !== 2"
                    @click="toggleExpand(scope.row)"
                    :src="
                      scope.row.expanded
                        ? 'http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/btn_caret_down%402x.png'
                        : 'http://ddttrader-website.oss-cn-hangzhou.aliyuncs.com/my-account/btn_caret_right%402x.png'
                    "
                    alt="展开/收回"
                    class="expand-icon"
                    style="width: 10px; height: 10px"
                  />
                  <!-- <img
                    v-else
                    src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMzMzP///wAAACH5BAEAAAAALAAAAAAQABAAAAIijI+py+0Po5y02ouz3pwXADs="
                    alt="占位图标"
                    class="placeholder-icon"
                    style="width: 10px; height: 10px;"
                  /> -->
                </span>
                {{ scope.row.name ? scope.row.name : "--" }}
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 其他表格字段 -->
        <el-table-column
          prop="id"
          :label="$t('proxy.text84') + '/' + $t('proxy.text65')"
          min-width="120px"
        />
        <el-table-column
          prop="roleTypeStr"
          :label="$t('proxy.text289')"
          min-width="90px"
        />
        <el-table-column
          prop="parentName"
          :label="$t('proxy.text257')"
          min-width="150px"
        />
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          prop="mobileAreaCode"
          :label="$t('proxy.text258')"
          align="center"
          min-width="100px"
        >
          <template #default="scope">
            {{ scope.row.mobileAreaCode ? scope.row.mobileAreaCode : "--" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          prop="phone"
          :label="$t('proxy.text89')"
          min-width="120px"
        >
          <template #default="scope">
            {{ scope.row.phone ? scope.row.phone : "--" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="180px"
          prop="email"
          align="center"
          :label="$t('proxy.text34')"
        >
          <template #default="scope">
            <div class="break-word">
              {{ scope.row.email ? scope.row.email : "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusStr"
          :label="$t('proxy.text153')"
          min-width="90px"
        >
          <template #default="scope">
            <span v-if="scope.row.roleType === 1">--</span>
            <span v-else>{{ scope.row.statusStr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="openStatusStr"
          :label="$t('proxy.text78')"
          min-width="120px"
        >
          <template #default="scope">
            <span v-if="scope.row.roleType === 1">--</span>
            <span v-else>{{ scope.row.openStatusStr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="createtime"
          :label="$t('proxy.text259')"
          align="center"
        ></el-table-column>
        <!-- 固定在右侧的操作列 -->
        <el-table-column
          min-width="250px"
          :label="$t('proxy.text139')"
          align="center"
          fixed="right"
        >
          <template #default="scope">
            <div class="button-group">
              <el-button
                class="view-account"
                @click="handleViewAccount(scope.row)"
              >
                {{ $t("proxy.text260") }}
              </el-button>
              <el-button
                class="transaction-history"
                @click="handleTransactionHistory(scope.row)"
              >
                {{ $t("proxy.text86") }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @current-change="handlePageChange"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        :total="totalEntries"
        :page-sizes="[10, 50, 100, 200]"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from "vue";
import apiService from "@/api/request";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const currentPath = ref(route.path); // 当前选中的菜单路径
    const searchForm = reactive({
      SProxyId: "",
      id: "",
      name: "",
      phone: "",
      email: "",
      status: "",
      openStatus: "",
      startTime: "",
      endTime: "",
    });

    const clientData = ref([]);
    const formattedAgents = ref([]);
    const visibleData = ref([]);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalEntries = ref(0);
    const agentConfig = computed(() => store.getters.getAgentConfig);

    const fetchAgents = async () => {
      try {
        const params = {
          containRoot: true,
        };
        const response = await apiService.proxyAllSubProxyList(params);
        formattedAgents.value = formatAgents(
          response.data.proxyTree ? response.data.proxyTree : []
        );
      } catch (error) {
        console.error("获取代理列表失败:", error);
      }
    };

    const formatAgents = (agentsList, level = 0) => {
      return agentsList.flatMap((agent) => {
        const indentedAgent = {
          proxyId: agent.proxyId,
          indentedName: `${" ㅤ".repeat(level)}${agent.proxyName}`,
        };
        const children = agent.childProxyInfo
          ? formatAgents(agent.childProxyInfo, level + 1)
          : [];
        return [indentedAgent, ...children];
      });
    };

    const fetchData = async () => {
      const params = {
        page: currentPage.value,
        limit: pageSize.value,
        SProxyId: searchForm.SProxyId,
        UserId: searchForm.id,
        Name: searchForm.name,
        Phone: searchForm.phone,
        Email: searchForm.email,
        Status: searchForm.status,
        OpenAccountStatus: searchForm.openStatus,
        StartTime: searchForm.startTime,
        EndTime: searchForm.endTime,
      };

      try {
        const response = await apiService.proxyClientList(params);
        clientData.value = response.data.list;
        updateVisibleData();
        totalEntries.value = response.data.count;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const toggleExpand = (row) => {
      row.expanded = !row.expanded;
      updateVisibleData();
    };

    const updateVisibleData = () => {
      const result = [];

      const addVisibleRows = (agent, level = 0) => {
        agent.level = level; // 添加层级信息
        result.push(agent);
        if (agent.expanded && agent.childList) {
          agent.childList.forEach((child) => addVisibleRows(child, level + 1)); // 递归处理子节点并增加层级
        }
      };

      clientData.value.forEach((agent) => addVisibleRows(agent));
      visibleData.value = result;
    };

    const searchFetchData = () => {
      currentPage.value = 1;
      fetchData();
    };

    const handlePageChange = (page) => {
      currentPage.value = page;
      fetchData();
    };

    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchData();
    };

    const handleViewAccount = (row) => {
      currentPath.value = "accountlist";
      router.push({
        name: "agentAccountList",
        query: { userId: row.id, activeMenu: "accountlist" },
      });
    };

    const handleTransactionHistory = (row) => {
      console.log("row", row);
      currentPath.value = "tradehistory";
      router.push({
        name: "agentTradeHistory",
        query: {
          name: row.name,
          userId: row.id,
          FundAccountId: row.fundAccountId,
          mt4LoginId: row.mt4LoginId,
          activeMenu: "tradehistory",
        },
      });
    };

    onMounted(() => {
      fetchData();
      fetchAgents();
    });

    return {
      searchForm,
      clientData,
      formattedAgents,
      visibleData,
      currentPage,
      pageSize,
      totalEntries,
      toggleExpand,
      searchFetchData,
      handlePageChange,
      handleSizeChange,
      handleViewAccount,
      handleTransactionHistory,
      agentConfig,
    };
  },
};
</script>

<style lang="less" scoped>
.date-range {
  display: inline-flex;
  align-items: center;
}

.date-separator {
  margin: 0 15px;
}

.pagination-container {
  margin-top: 20px;
}

.view-account,
.transaction-history {
  font-size: 14px;
  border: none;
  padding: 0;
  margin: 2px, 0;
}

.expand-wrapper {
  display: flex;
  align-items: center;
  overflow: hidden; /* 隐藏超出部分 */
}

.expand-icon {
  cursor: pointer;
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.name-cell,
.client-cell {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-grow: 1; /* 让名称部分填满剩余空间 */
  margin-left: 24px;
}

.client-cell .cell {
  justify-content: flex-start !important; /* 覆盖公共样式的居中对齐 */
}

.disabled-text {
  color: #666d7f;
  font-size: 14px;
}

.placeholder-icon {
  padding: 4px;
}

.button-group {
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
  gap: 10px; /* 按钮之间的间距 */
}

.view-account,
.transaction-history {
  font-size: 14px;
  padding: 0px;
  margin: 0;
  color: inherit; /* 按钮文字继承颜色 */
}

.view-account {
  color: #51b4f1; /* 视图按钮颜色 */
}

.transaction-history {
  color: #67c23a; /* 交易记录按钮颜色 */
}

::v-deep(.el-table th),
::v-deep(.el-table td),
::v-deep(.el-table-column__header) {
  border: none !important; /* 隐藏表格的边框 */
}

.header-with-line {
  position: relative;
  display: inline-block;
  width: 100%; /* 确保宽度覆盖整个单元格 */
  text-align: left; /* 确保表头文字左对齐 */
  padding-left: 24px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #000000;

  /* 添加伪元素用于小短线 */
  &::after {
    content: "";
    position: absolute;
    right: -12px; /* 调整为与 table border 位置重合 */
    top: 50%;
    width: 1px; /* 短线宽度 */
    height: 22px; /* 短线高度 */
    background-color: #d8d8d8; /* 短线颜色 */
    transform: translateY(-50%); /* 短线垂直居中 */
  }
}

::v-deep(.el-table__border-left-patch) {
  width: 0px;
}

.el-table::before {
  height: 0px;
}
</style>
